import type { CommunityDetail } from 'models';
import { useState } from 'react';
import { usePermissions } from 'permissions';
import { Button, Card, Col, RichTextRenderer, Row, Title } from 'ui';
import { EditModal } from './edit-modal';

type P = {
  community: CommunityDetail;
};

const Description = ({ community }: P) => {
  const [isOpenInviteModal, setIsOpenInviteModal] = useState(false);

  const { canManageCommunity } = usePermissions();

  return (
    <>
      <Card
        className="community-description"
        title={
          <Row justify="space-between">
            <Col>
              <Title level={4}>Description</Title>
            </Col>
            {canManageCommunity({ community }) && (
              <Col>
                <Button
                  onClick={() => {
                    setIsOpenInviteModal(true);
                  }}
                  size="large"
                  type="link-primary"
                >
                  Edit
                </Button>
              </Col>
            )}
          </Row>
        }
      >
        <RichTextRenderer data={community.htmlDescription} />
      </Card>
      <EditModal
        community={community}
        isOpened={isOpenInviteModal}
        onClose={() => {
          setIsOpenInviteModal(false);
        }}
      />
    </>
  );
};

export default Description;
